import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { serverInfo } from "../../../App";

const FinalAssessmentTable = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const {
    data,
    tableHead,
    auditionRoundInfo,
    setAuditionRoundInfo,
    videoType,
  } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row mx-1" style={{ overflowX: "auto" }}>
          <Table className="table w-100" striped bordered hover variant="dark">
            <thead>
              <tr>
                {tableHead &&
                  tableHead.map((heading) => (
                    <th className="bg-warning text-center">{heading}</th>
                  ))}
              </tr>
            </thead>

            <tbody>
              {currentItems &&
                currentItems.map((user, index) => (
                  <tr key={index}>
                    <td>
                      {user.participant?.first_name}
                      {user.participant?.last_name}
                    </td>
                    <td>{user.participant?.email}</td>
                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :{video.user_vote_avg_mark?video.user_vote_avg_mark:0}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :{video.group_b_jury_mark}
                          </span>
                        ))}
                        {videoType == "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.group_b_jury_mark == null
                                        ? 0
                                        : v.group_b_jury_mark)),
                                  0
                                ) / auditionRoundInfo.video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.group_b_jury_mark == null
                                        ? 0
                                        : v.group_b_jury_mark)),
                                  0
                                ) / auditionRoundInfo.appeal_video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :{video.group_c_jury_mark}
                          </span>
                        ))}
                        {videoType == "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.group_c_jury_mark == null
                                        ? 0
                                        : v.group_c_jury_mark)),
                                  0
                                ) / auditionRoundInfo.video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.group_c_jury_mark == null
                                        ? 0
                                        : v.group_c_jury_mark)),
                                  0
                                ) / auditionRoundInfo.appeal_video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :{video.jury_final_mark}
                          </span>
                        ))}
                        {videoType == "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.jury_final_mark == null
                                        ? 0
                                        : v.jury_final_mark)),
                                  0
                                ) / auditionRoundInfo.video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      (v.jury_final_mark == null
                                        ? 0
                                        : v.jury_final_mark)),
                                  0
                                ) / auditionRoundInfo.appeal_video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default FinalAssessmentTable;
